import { combineReducers } from "@reduxjs/toolkit";
import quiz from "./quiz";

const rootReducers = combineReducers({quiz});

export default rootReducers;